import styled from "styled-components";

import { getBaseFont } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";
import { Header2 as SitesparkHeader2 } from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero/header2";

export const Header2 = styled(SitesparkHeader2)(
  [""],
  getBaseFont("brandon-light")
);
